<template>
    <DModal
        :title="__('customers.contracts.create_contract_tree.technical_details')"
        is-confirm
        :show="showModal"
        is-medium
        @confirm="submitForm"
        @close="$emit('close-modal')"
    >
        <DCard
            padding
            class="technical-details-form"
        >
            <div v-if="form.config_values.length > 0">
                <DFormRow
                    v-for="(row, index) in form.config_values"
                    :key="index"
                    :label="row.translated_name"
                    :is-required="row.required"
                    :error="getErrorMessage(row)"
                >
                    <DSwitch
                        v-if="row.type === 'bool'"
                        :id="`option_${row.name}`"
                        v-model="form.config_values[index].value"
                        color="success"
                        variant="3d"
                        :description="row.description"
                    />
                    <DInput
                        v-if="['string', 'integer', 'email', 'numeric'].includes(row.type)"
                        :id="`option_${row.name}`"
                        v-model="form.config_values[index].value"
                        :description="row.description"
                    />
                    <DFormTextarea
                        v-if="row.type === 'text'"
                        :id="`option_${row.name}`"
                        v-model="form.config_values[index].value"
                        :description="row.description !== null ? row.description : __('messages.select_value')"
                        rows="8"
                    />
                    <DSelect
                        v-if="row.type === 'list'"
                        :id="`option_${row.name}`"
                        v-model="form.config_values[index].value"
                        :options="row.options"
                        :description="row.description"
                        :placeholder="row.description"
                        @update:value="(value) => setListValue(index, value, row.options)"
                    />
                    <DMultiSelect
                        v-if="row.type === 'multiselect'"
                        :id="`contract-option-${row.name}`"
                        v-model="form.config_values[index].value"
                        :search="true"
                        :selection="true"
                        :options="row.options"
                        :disabled="contract.id && !row.editable"
                        :is-valid="isFormFieldValid(`config_values.${row.name}.value`)"
                        :description="row.description"
                        @update="(values) => setMultiselectValue(index, values, row.options, row.name)"
                    />
                    <DMultiSelect
                        v-if="row.type === 'search_list'"
                        :id="`contract-option-${row.name}`"
                        v-model="form.config_values[index].value"
                        :search="true"
                        :selection="false"
                        :multiple="false"
                        :options="row.options"
                        :disabled="contract.id && !row.editable"
                        :is-valid="isFormFieldValid(`config_values.${row.name}.value`)"
                        :description="row.description"
                        @update="(values) => setMultiselectValue(index, values, row.options, row.name)"
                    />
                    <DContractOptionModal
                        v-if="row.type === 'modal'"
                        :id="`contract-option-${row.name}`"
                        :display-value="getDisplayValue(form.config_values[index])"
                        :disabled="contract.id && !row.editable"
                        :is-valid="isFormFieldValid(`config_values.${row.name}.value`)"
                        :description="row.description"
                        :name="row.name"
                        :fulfillment-module="form.fulfillment_module"
                        @update:modelValue="(value) => setModalValue(index, value)"
                    />
                </DFormRow>
            </div>
            <DAlert
                v-else
                class="m-0"
                color="warning"
            >
                {{ __('customers.contracts.create_contract_tree.no_data') }}
            </DAlert>
        </DCard>
    </DModal>
</template>

<script>
import DContractOptionModal from '~@/Components/Fulfillment/Options/DContractOptionModal'

export default {
    name: 'TechnicalDetailsModal',
    components: {
        DContractOptionModal
    },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'submitTechnicalDetails'],
    data () {
        return {
            form: JSON.parse(JSON.stringify(this.contract)) // clone object
        }
    },
    methods: {
        submitForm () {
            this.$emit('submitTechnicalDetails', this.form)
        },
        getErrorMessage (row) {
            if (!this.errors[`${row.name}`]) {
                return this.errors[`${row.name}`]
            }

            return this.errors[`${row.name}`].replaceAll('config values.', '').replaceAll('.value', '')
        },
        setListValue (key, value, options) {
            this.form.config_values[key].value = value
            this.form.config_values[key].display_value = options.find((item) => item.value === value).label
        },
        setMultiselectValue (key, values, options, rowName) {
            this.form.config_values[key].value = values.join(',')

            if (rowName === 'industry') {
                this.form.config_values[key].display_value = values.join(',') + ' - ' + options.map((item) => values.includes(String(item.value)) ? item.text : null)
                    .filter((item) => item !== null)
                    .join(',')

                this.form.config_values[key].options.forEach((option) => {
                    values.forEach((value) => {
                        if (option.value === String(value)) {
                            option.selected = true
                        } else {
                            option.selected = false
                        }
                    })
                })
            } else {
                this.form.config_values[key].display_value = options.map((item) => values.includes(String(item.value)) ? item.text : null)
                    .filter((item) => item !== null)
                    .join(',')
            }
        },
        setModalValue (key, value) {
            if (typeof value === 'object') {
                this.form.config_values[key].value = value.value
                this.form.config_values[key].display_value = value.display_value
            } else {
                this.form.config_values[key].value = value
            }
        },
        getDisplayValue (item) {
            return item.display_value === null ? item.value : item.display_value
        }
    }
}
</script>

<style lang="scss" scoped>
.technical-details-form {
    display: grid;
    grid-gap: 15px;
    border-radius: 0 !important;
    border-bottom: 0 !important;
}
</style>
